import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {

  constructor(private dataService: DataService) { }

  getProviderList() {
    return this.dataService.getRecord('/api/ServiceProvider/getProviderList');
  }

  getAllProviderList() {
    return this.dataService.getRecord('/api/ServiceProvider/getAllProviderList');
  }

  getServiceProviderList() {
    return this.dataService.getRecord('/api/ServiceProvider/getAllServiceProviderList/');
  }

  getManageServiceProviderList(searchQuery) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getAllServiceProviderList/', searchQuery);
  }

  //getContactAllList(searchQuery) {
  //    return this.dataService.getRecordWithParams('/api/ServiceProviderContact/getContactAllList/', searchQuery);
  //}

  getServiceProviderbyId(serviceproviderId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getServiceProviderbyId/' + serviceproviderId);
  }

  getrContactListbyId(serviceproviderId: number) {

    return this.dataService.getRecord('/api/ServiceProviderContact/getrContactListbyId/' + serviceproviderId);
  }
  getServiceProviderContactMapping(serviceproviderId: number) {

    return this.dataService.getRecord('/api/ServiceProviderContact/getServiceProviderContactMapping/' + serviceproviderId);
  }

  getContactbyId(contactId: number) {

    return this.dataService.getRecord('/api/ServiceProviderContact/getContactbyId/' + contactId);
  }

  deleteSPContact(contactId: number) {

    return this.dataService.getRecord('/api/ServiceProviderContact/deleteSPContact/' + contactId);
  }

  saveServiceProvider(serviceprovider: any) {

    return this.dataService.post('/api/ServiceProviderContact/saveServiceProvider/', serviceprovider);
  }

  editContact(contact: any) {

    return this.dataService.post('/api/ServiceProviderContact/editContact/', contact);
  }
  serviceProviderSave(serviceprovider: any) {
    return this.dataService.post('/api/ServiceProvider/saveServiceProvider/', serviceprovider);
  }
  serviceProviderCommonSave(serviceprovider: any) {
    return this.dataService.post('/api/ServiceProvider/CommonSaveServiceProvider/', serviceprovider);
  }

  deleteserviceProvider(seviceProviderId: number) {
    return this.dataService.delete('/api/ServiceProvider/Delete/' + seviceProviderId);
  }
  getTargetListById(serviceproviderId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getTargetListById/' + serviceproviderId);
  }
  getSLAListById(serviceproviderId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getSLAListById/' + serviceproviderId);
  }

  salesTargetSave(serviceprovider: any) {
    return this.dataService.post('/api/ServiceProvider/saveSalesTarget/', serviceprovider);
  }

  getSalesUserList(searchQuery: number) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getSalesUserList/', searchQuery);
  }

  getManageSalesTarget(refresh) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getManageSalesTarget', refresh);
  }

  getSalesTargetListbyId(userId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getSalesTargetListbyId/' + userId);
  }

  getSalesUserNamebyId(userId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getSalesUserNamebyId/' + userId);
  }

  getHCYearFormat(userId: number) {

    return this.dataService.getRecord('/api/ServiceProvider/getHCYearFormat/' + userId);
  }

  getServiceProviderByDate(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getServiceProviderByDate', searchQuery);
  }

  getServiceProviderByDatePerYear(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getServiceProviderByDatePerYear', searchQuery);
  }

  getSalesTargetFilterSearch(searchQuery: any) {
    return this.dataService.getRecordWithParams('/api/ServiceProvider/getSalesTargetFilterSearch', searchQuery);
  };

  deleteSalesTarget(salesTargetId: number) {
    return this.dataService.delete('/api/ServiceProvider/deleteSalesTarget/' + salesTargetId);
  }

  getLocationForRouteNetworks() {
    return this.dataService.getRecord('/api/ServiceProviderRequest/getLocationForRouteNetworks');
  };

  checkOpenServeWebConnect(productId: number) {
    return this.dataService.getRecord('/api/ServiceProvider/CheckOpenServeWebConnect/' + productId);
  }
}
